import apiManager from '@/api';
import {
  setLocalStorageItemWithExpiration,
  clearLocalStorageItemWithExpiration,
  getLocalStorageItemWithExpiration,
} from '../../utils/localStorageHelper';

const USER_KEY = process.env.VUE_APP_USER;
const ROLE_KEY = process.env.VUE_APP_ROLE_NAME;
const TOKEN_KEY = process.env.VUE_APP_TOKEN_NAME;
const EXPIRATION_IN_SECONDS = 43200000;

export default {
  namespaced: true,
  state: {
    userId: null,
    role: null,
    token: null,
  },
  getters: {
    userId: (state) => state.userId,
    role: (state) => state.role,
    token: (state) => state.token,
    isAuthenticated: (state) => state.token !== null,
  },
  mutations: {
    setUser: (state, user) => {
      state.userId = user.userId;
      state.role = user.role;
      state.token = user.token;
    },
  },
  actions: {
    async uid({ dispatch, commit }, args) {
      const { data } = await apiManager.Login.uid(args);
      commit('setUser', data);
      dispatch('setAuthentication', data);
    },
    checkLogin({ commit, getters }) {
      const user = {
        userId: getLocalStorageItemWithExpiration(USER_KEY),
        role: getLocalStorageItemWithExpiration(ROLE_KEY),
        token: getLocalStorageItemWithExpiration(TOKEN_KEY),
      };
      commit('setUser', user);
      apiManager.setAuthHeader(getters.token);
    },
    async hasRole({ getters }, allowedRoles) {
      if (!allowedRoles) {
        return false;
      }
      return allowedRoles.includes(getters.role?.toUpperCase() ?? '');
    },
    async getToken({ dispatch, commit }, oauthObject) {
      const data = await apiManager.login.token(oauthObject);

      await commit('setUser', data);
      dispatch('setAuthentication', data);
    },
    async exchangeToken({ dispatch, commit }, exchangeToken) {
      const data = await apiManager.login.exchange(exchangeToken);

      await commit('setUser', data);
      dispatch('setAuthentication', data);
    },
    async getUidToken({ dispatch, commit }, args) {
      const data = await apiManager.login.uid(args);

      commit('setUser', data);
      dispatch('setAuthentication', data);

      return data;
    },
    setApplicationId({ commit }, applicationId) {
      commit('setApplicationId', applicationId);
    },
    setAuthentication({ getters }, userToken) {
      setLocalStorageItemWithExpiration(USER_KEY, userToken.userId, EXPIRATION_IN_SECONDS);
      setLocalStorageItemWithExpiration(ROLE_KEY, userToken.role, EXPIRATION_IN_SECONDS);
      setLocalStorageItemWithExpiration(TOKEN_KEY, userToken.token, EXPIRATION_IN_SECONDS);

      apiManager.setAuthHeader(getters.token);
    },
    logout({ dispatch }) {
      clearLocalStorageItemWithExpiration(USER_KEY);
      clearLocalStorageItemWithExpiration(ROLE_KEY);
      clearLocalStorageItemWithExpiration(TOKEN_KEY);
      dispatch('checkLogin');
    },
  },
};
